<app-leveltwo [pageName]="'Real Estate Fraud'">
    <div heading="General Info" class="General">
      <h3>{{'RealEstateFraud.SearchTitle'|translate}}</h3>
      <p>{{'RealEstateFraud.Thedream'|translate}}</p>
      <p>{{'RealEstateFraud.Unscrupulous'|translate}}</p>
      <p>{{'RealEstateFraud.While'|translate}}</p>
      <p><b>{{'RealEstateFraud.Formore'|translate}} <a href="https://dcba.lacounty.gov" target="_blank">dcba.lacounty.gov</a></b></p>


    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
